export const StorageKey = {
  Id: 'identity',
  PreviousId: 'prevIdentity',
  SessionId: 'sessionId',
  Global: 'spdl',
} as const;

export const Channels = {
  Broadcast: 'spdl-channel',
} as const;
